import { render, staticRenderFns } from "./QRView.vue?vue&type=template&id=058027f6&scoped=true"
import script from "./QRView.vue?vue&type=script&lang=js"
export * from "./QRView.vue?vue&type=script&lang=js"
import style1 from "./QRView.vue?vue&type=style&index=1&id=058027f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058027f6",
  null
  
)

export default component.exports